// extracted by mini-css-extract-plugin
export default {"error-page":"styles_error-page__UCDVt","error-page__content":"styles_error-page__content__2h+uH","error-page__dark":"styles_error-page__dark__k6HhL"};